import ReactQuillCustomJP from "@lhd/components/ReactQuillCustomJP";
import { AppPartType, ItemConfigDataType } from "../../AppForm/types";

import { Form } from "antd";
import { getConfigAppPartType, trimHTML } from "../../utils";
import ReactQuill from "react-quill";
import { useEffect, useRef, useState } from "react";
import { ROW_HEIGHT } from "../../AppForm/constants";
import { Styles } from "./styled";

interface IProps {
  nameItem: string;
  item: AppPartType;
  parentItem?: AppPartType;
  onChange?: (state: string) => void;
  isDisable?: boolean;
  isTable?: boolean;
  preview?: boolean;
  isPDF?: boolean;
  styleColor?: React.CSSProperties;
  className?: string;
}

const RichText = (props: IProps) => {
  const {
    nameItem,
    item,
    onChange,
    isDisable,
    isTable = false,
    preview,
    isPDF,
    styleColor = {},
    className,
  } = props;
  const { isHiddenLabel, labelText, appPartType } = getConfigAppPartType(item);

  const [isFocus, setIsFocus] = useState(false);
  const refHasFocus = useRef(false);

  const minHeight = isDisable ? 0 : item.item_config_data.h * ROW_HEIGHT - 30;
  const idRichText = nameItem + "-rich_text";
  const quillRef = useRef<ReactQuill>();
  const containerRef = useRef<HTMLDivElement>(null);
  const handleRemoveEmptyStringRich = (html: string) => {
    if (html && !isFocus) {
      const newValue = trimHTML(html);
      if (html === newValue || html === "<p><br></p>") return;
      quillRef.current?.editor?.clipboard.dangerouslyPasteHTML(newValue);
      quillRef.current?.editor?.blur();
      onChange && onChange(newValue);
    }
  };

  useEffect(() => {
    const handleSetFocus = (e: MouseEvent) => {
      const htmlElememt = e.target as HTMLElement;
      const container = htmlElememt.closest(`#${CSS.escape(idRichText)}`);
      setIsFocus(!!container);
    };
    if (isFocus) window.addEventListener("click", handleSetFocus);
    return () => {
      window.removeEventListener("click", handleSetFocus);
    };
  }, [isFocus]);

  useEffect(() => {
    if (!isFocus) {
      handleRemoveEmptyStringRich(
        quillRef.current?.props.value?.toString() || "",
      );
    }
  }, [isFocus]);
  useEffect(() => {
    if (containerRef.current && quillRef.current) {
      const toolbar = containerRef.current.querySelector(
        ".ql-toolbar",
      ) as HTMLElement;
      const heightToolbar = toolbar?.offsetHeight || 60;
      const container = quillRef.current.editingArea as HTMLDivElement;
      if (container) {
        container.style.minHeight = minHeight - heightToolbar + "px";
      }
    }
  }, [containerRef.current, quillRef.current, isDisable]);

  return (
    <Styles
      id={idRichText}
      onClick={() => {
        refHasFocus.current && setIsFocus(true);
      }}
      className="dasdsdsadasdadadasd"
      ref={containerRef}
      color={styleColor?.color}
      background={styleColor?.background}
    >
      <Form.Item
        label={
          isHiddenLabel ? (
            false
          ) : (
            <div className="no-wrap-text" title={labelText}>
              {labelText}
            </div>
          )
        }
        name={nameItem}
        className={`container_rich-text ${className}`}
        rules={[
          {
            required: item.is_required_field,
            message: `必須項目です`,
          },
          () => ({
            validator(_, value) {
              if (
                item.is_required_field &&
                value?.blocks?.filter(
                  (block: any) => block.text !== "" && block.text !== "\n",
                )?.length === 0
              ) {
                return Promise.reject(
                  new Error("整数で指定のフィルードです。ご確認ください。"),
                );
              }
              return Promise.resolve();
            },
          }),
        ]}
        validateTrigger="onBlur"
      >
        <ReactQuillCustomJP
          style={{
            minHeight,
            ...styleColor,
          }}
          quillRef={quillRef}
          onFocus={() => (refHasFocus.current = true)}
          readOnly={!!isDisable || preview}
          onChange={(state) => {
            onChange && onChange(state);
          }}
        />
      </Form.Item>
    </Styles>
  );
};
export default RichText;
